// extracted by mini-css-extract-plugin
module.exports =  {"container":"style-module_container__Wt6xxffQinvq73WDvczA","wide":"style-module_wide__LQXndazhAg3V8WdxLGzc","buttons":"style-module_buttons__bX8OJK2YGdS6tE4FiHcO"};